import axios from 'axios';
import { MDBBtn, MDBContainer, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader } from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { NavbarContext } from '../context/NavProvider';
import { fetchMainPageData } from '../utils/Common';
import GalleryComponent from './GalleryComponent';
import Reviews from './reviews/Reviews';
const ItemView = ({ item, show, handleViewModalClose,createCart, weight, setWeight, qty, setQty}) => {

  const { setIsPricing,pageData,setPageData,setBusiness} = useContext(NavbarContext);
  useEffect(() => {
    if (!pageData) {
      fetchMainPageData(setPageData,setIsPricing,pageData,setBusiness);
      
    }
  }, []);

  const [reviews, setReviews] = useState([]);
  const baseUrl = process.env.REACT_APP_INVENTORY_URL;
  useEffect(() => {
   if(item?.id){
    axios.get(`${baseUrl}/reviews/${item?.id}`)
      .then(response => {
        setReviews(response.data);
      })
      .catch(error => {
        console.error("Error fetching reviews:", error);
      });
    }
  }, [ baseUrl, item?.id]);
  return (
    <MDBContainer>
      <MDBModal className='modal-backdrop.show'  open={show} onClose={handleViewModalClose}>
    
        <MDBModalDialog centered={true}  style={{ color: '#ac2bac' }} size="xl">
        <MDBModalContent>   
        <MDBModalHeader>
             
              <MDBBtn className='btn-close' color='none' onClick={handleViewModalClose}></MDBBtn>
            </MDBModalHeader>      
          <MDBModalBody>            
            <GalleryComponent item={item} createCart={createCart}  weight={weight} setWeight={setWeight} qty={qty} setQty={setQty} reviews={reviews}/>      
            <Reviews item={item} reviews={reviews} setReviews={setReviews}/> 
          </MDBModalBody>
          <MDBModalFooter>   <MDBBtn size='sm'        
          color="link"
          onClick={handleViewModalClose}
        >
          Close
        </MDBBtn> </MDBModalFooter>
          </MDBModalContent>
         
        </MDBModalDialog>
       
      </MDBModal>
    </MDBContainer>
  );
}
ItemView.propTypes = {
  item: PropTypes.shape({
    thumbnails: PropTypes.arrayOf(PropTypes.string),
    name: PropTypes.string,
    subdomain: PropTypes.string,
    domainIds: PropTypes.arrayOf(PropTypes.string),
    domainIdToName: PropTypes.objectOf(PropTypes.string),
    id:PropTypes.string,
  }),
  show: PropTypes.bool,
  createCart:PropTypes.func,
  weight:PropTypes.object,
  qty:PropTypes.object,
  setWeight:PropTypes.func,
  setQty:PropTypes.func,
  handleViewModalClose: PropTypes.func,
};



export default ItemView;
